
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5iRsI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $24902acfefadcb18$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    subHeading: {
        id: "blog-posts-macro.sub-heading",
        defaultMessage: "Blog Posts"
    },
    createdBy: {
        id: "blog-posts-macro.created-by",
        defaultMessage: "created by"
    },
    emptyHeading: {
        id: "blog-posts-macro.empty-heading",
        defaultMessage: "Blog stream"
    },
    emptyContent: {
        id: "blog-posts-macro.empty-content",
        defaultMessage: "Create a blog post to share news and announcements with your team and company."
    },
    createPost: {
        id: "blog-posts-macro.create-post",
        defaultMessage: "Create blog post"
    },
    error: {
        id: "blog-posts-macro.error",
        defaultMessage: "Unable to display blog posts."
    },
    loading: {
        id: "blog-posts-macro.loading",
        defaultMessage: "Loading blog posts\u2026"
    },
    postedBy: {
        id: "blog-posts-macro.posted-by",
        defaultMessage: "{author} posted on {date}"
    },
    excerptPostedOn: {
        id: "blog-posts-macro.excerpt-posted-on",
        defaultMessage: "posted on {date}"
    },
    loadMore: {
        id: "blog-posts-macro.load-more",
        defaultMessage: "Load more blogs..."
    }
});






var $gLc6G = parcelRequire("gLc6G");


var $f9Oe5 = parcelRequire("f9Oe5");





var $jMyy4 = parcelRequire("jMyy4");




const $41c5e05b9a8c19b6$export$7a795ea2fa184b71 = (params, currentSpaceKey)=>{
    const variables = (0, $cozmU.useMemo)(()=>(0, $gLc6G.buildQueryVariables)(params, currentSpaceKey), [
        currentSpaceKey,
        params
    ]);
    const maxResults = (0, $gLc6G.getMaxResults)(params);
    const [loadMoreError, setLoadMoreError] = (0, $cozmU.useState)();
    const [isLoadingMore, setIsLoadingMore] = (0, $cozmU.useState)(false);
    const { data: data, error: error, loading: loading, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)((0, $f9Oe5.default), {
        variables: variables,
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "@confluence/blog-posts-macro"
    });
    const loadedCount = data?.search?.nodes?.length ?? 0;
    const remainingCount = Math.max(maxResults - loadedCount, 0);
    const pageInfo = data?.search?.pageInfo;
    const isInitialLoading = loading && !data?.search;
    const canLoadMore = variables.includeEntireBody && remainingCount > 0 && Boolean(pageInfo?.hasNextPage) && Boolean(pageInfo?.endCursor);
    const loadMore = (0, $cozmU.useCallback)(async ()=>{
        const endCursor = pageInfo?.endCursor;
        if (!canLoadMore || !endCursor || loading || isLoadingMore) return;
        setLoadMoreError(undefined);
        setIsLoadingMore(true);
        await fetchMore({
            variables: {
                after: endCursor,
                first: Math.min((0, $gLc6G.ENTIRE_MODE_PAGE_SIZE), remainingCount)
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.search) return prev;
                return {
                    ...prev,
                    search: {
                        ...prev.search ?? {},
                        count: fetchMoreResult.search.count ?? prev.search?.count ?? null,
                        nodes: [
                            ...prev.search?.nodes ?? [],
                            ...fetchMoreResult.search.nodes ?? []
                        ],
                        pageInfo: fetchMoreResult.search.pageInfo
                    }
                };
            }
        }).catch((err)=>{
            setLoadMoreError(err instanceof Error ? err : new Error(String(err)));
        }).finally(()=>{
            setIsLoadingMore(false);
        });
    }, [
        canLoadMore,
        fetchMore,
        isLoadingMore,
        loading,
        pageInfo?.endCursor,
        remainingCount
    ]);
    return {
        data: data,
        error: error,
        loading: isInitialLoading,
        cql: variables.cql,
        hasNextPage: canLoadMore,
        isLoadingMore: isLoadingMore,
        loadMore: canLoadMore ? loadMore : undefined,
        loadMoreError: loadMoreError
    };
};


const $5c663987d2c4a146$var$buildMacroParameters = (macroParams)=>({
        content: macroParams?.content?.value,
        time: macroParams?.time?.value,
        labels: macroParams?.labels?.value ?? macroParams?.label?.value,
        spaces: macroParams?.spaces?.value ?? macroParams?.space?.value,
        max: macroParams?.max?.value ?? macroParams?.maxResults?.value,
        sort: macroParams?.sort?.value,
        reverse: macroParams?.reverse?.value,
        author: macroParams?.author?.value
    });
const $5c663987d2c4a146$export$5d6b4e71896e8f23 = (macroParams)=>macroParams?.content?.value ?? 'entire';
const $5c663987d2c4a146$export$bcd1293b3c1159b6 = (macroParams, macroDefaultProps)=>{
    const spaceKey = macroDefaultProps.spaceKey;
    const contentMode = $5c663987d2c4a146$export$5d6b4e71896e8f23(macroParams);
    const { data: data, error: error, hasNextPage: hasNextPage, isLoadingMore: isLoadingMore, loadMore: loadMore, loadMoreError: loadMoreError, loading: loading } = (0, $41c5e05b9a8c19b6$export$7a795ea2fa184b71)(macroParams ?? {}, spaceKey);
    const nodes = (0, $cozmU.useMemo)(()=>(data?.search?.nodes ?? []).filter((0, $gLc6G.isBlogPostNode)), [
        data?.search?.nodes
    ]);
    const dataMacroParameters = (0, $cozmU.useMemo)(()=>$5c663987d2c4a146$var$buildMacroParameters(macroParams), [
        macroParams
    ]);
    const serializedMacroParameters = (0, $cozmU.useMemo)(()=>JSON.stringify(dataMacroParameters), [
        dataMacroParameters
    ]);
    return {
        contentMode: contentMode,
        data: data,
        error: error,
        hasNextPage: hasNextPage,
        isLoadingMore: isLoadingMore,
        loadMore: loadMore,
        loadMoreError: loadMoreError,
        loading: loading,
        nodes: nodes,
        serializedMacroParameters: serializedMacroParameters,
        spaceKey: spaceKey
    };
};


/* TitlesList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");








var $I7hWB = parcelRequire("I7hWB");


var $d4GYd = parcelRequire("d4GYd");


var $7vK9E = parcelRequire("7vK9E");








var $a6t12 = parcelRequire("a6t12");


var $jJK3p = parcelRequire("jJK3p");





const $5dc99b02bed969e7$var$styles = {
    listContainer: "_85i512x7",
    subHeading: "_179ria51 _syaz1rpy",
    titlesUl: "_1yt4ze3t _2mzuglyw",
    blogItem: "_1reo15vq _18m915vq _1rjcu2gc _18zr12x7 _179ria51 _1pfhze3t _irr31dpa",
    titleRow: "_zulpu2gc _1e0c1txw _4cvr1y6m _1bah1yb4 _1n261g80",
    leftMeta: "_zulp1b66 _1e0c1txw _4cvr1y6m _16jlkb7n _i0dlqcxa _1ul9idpf _1n261g80",
    rightMeta: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bahesu3 _ahbq1wug _1n261g80",
    blogIcon: "_1e0c1txw _4cvr1h6o _1o9zidpf _syazazsu",
    titleLinkGroup: "_zulpu2gc _1e0c1txw _4cvr1q9y _1ul9idpf _p12f1osq",
    titleTextGroup: "_1e0c1ule _1ul9idpf _1i4qfg65",
    titleAnchor: "_1i4qfg65",
    subtleAnchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1rpy _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $5dc99b02bed969e7$export$9c7aae348aeccd51 = ({ nodes: nodes })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-posts-titles-list",
        className: (0, $hekY6.default)([
            $5dc99b02bed969e7$var$styles.listContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dc99b02bed969e7$var$styles.subHeading
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).subHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $5dc99b02bed969e7$var$styles.titlesUl
    }, nodes.map((node)=>{
        const content = node.content;
        if (!content) return null;
        const createdDate = (0, $gLc6G.getCreatedDate)(node);
        const authorName = (0, $gLc6G.getAuthorName)(node);
        const authorAccountId = (0, $gLc6G.getAuthorAccountId)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: content.id,
            xcss: $5dc99b02bed969e7$var$styles.blogItem,
            testId: "blog-post-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleRow
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.leftMeta
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleLinkGroup
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.blogIcon
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: "",
            color: "currentColor"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.titleTextGroup
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
            href: (0, $gLc6G.getContentUrl)(node),
            xcss: $5dc99b02bed969e7$var$styles.titleAnchor
        }, content.title), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "span",
            color: "color.text.subtlest"
        }, intl.formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).createdBy)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
            userId: authorAccountId,
            fullName: authorName,
            behavior: "link",
            isUnderlinedByDefault: false,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- style overrides to match legacy macro subtle link styling
                color: "var(--ds-text-subtlest, #6B6E76)"
            }
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5dc99b02bed969e7$var$styles.rightMeta
            ])
        }, Boolean(content.space?.name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
            href: (0, $gLc6G.getSpaceUrl)(node),
            xcss: $5dc99b02bed969e7$var$styles.subtleAnchor,
            testId: "blog-post-space-link"
        }, content.space?.name), Boolean(createdDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, (0, $gLc6G.formatSmartDate)(createdDate, intl)))));
    })));
};


/* ExcerptsList.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $arQY7 = parcelRequire("arQY7");





var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");





















var $dF6Hu = parcelRequire("dF6Hu");

const $ea3d6e5aceb5d616$export$af9dc05418a334e = ({ atlasDocFormat: atlasDocFormat, mediaToken: mediaToken, contentId: contentId, spaceKey: spaceKey, spaceId: spaceId, RendererWrapper: RendererWrapper, fallback: fallback = null })=>{
    const adfDocument = (0, $cozmU.useMemo)(()=>{
        return atlasDocFormat ? (0, $dF6Hu.parseNestedAdfDocument)(atlasDocFormat) : null;
    }, [
        atlasDocFormat
    ]);
    if (adfDocument) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RendererWrapper, {
        adf: adfDocument.content,
        targetContentId: contentId,
        targetSpaceKey: spaceKey,
        targetSpaceId: spaceId,
        mediaToken: mediaToken ?? undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback);
};


/* LabelsList.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eY4uS = parcelRequire("eY4uS");


var $3DjKS = parcelRequire("3DjKS");




const $bc0342895ad69cf4$var$styles = {
    labelsContainer: "_1q51u2gc"
};
const $bc0342895ad69cf4$export$2d4801a6a75948a8 = ({ labels: labels, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-post-labels",
        className: (0, $hekY6.default)([
            $bc0342895ad69cf4$var$styles.labelsContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3DjKS.default), null, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eY4uS.default), {
            key: label,
            text: label,
            href: (0, $gLc6G.getLabelUrl)(label, spaceKey),
            color: "standard",
            testId: "blog-post-label"
        }))));


const $fe30a19c14203e0b$var$styles = {
    excerptListingContainer: "_1rjc1ejb _179ria51",
    excerptTitle: "_11c810sd _6rthv77o",
    excerptTitleLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1",
    excerptMeta: "_zulp1b66 _6rthu2gc _1pfhv77o _1e0c1txw _4cvr1h6o _1n261g80"
};
const $fe30a19c14203e0b$export$d55fd724d7ffd08 = ({ nodes: nodes, contentMode: contentMode, RendererWrapper: RendererWrapper })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "blog-posts-excerpts-list"
    }, nodes.map((node)=>{
        const content = node.content;
        if (!content) return null;
        const createdDate = (0, $gLc6G.getCreatedDate)(node);
        const avatarUrl = (0, $gLc6G.getAuthorAvatarUrl)(node);
        const authorName = (0, $gLc6G.getAuthorName)(node);
        const authorAccountId = (0, $gLc6G.getAuthorAccountId)(node);
        const labels = (0, $gLc6G.getLabels)(node);
        const spaceKey = content.space?.key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: content.id,
            "data-testid": "blog-post-item",
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptListingContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            gap: "space.200",
            alignItems: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "large",
            name: authorName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptTitle
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
            href: (0, $gLc6G.getContentUrl)(node),
            xcss: $fe30a19c14203e0b$var$styles.excerptTitleLink
        }, content.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $fe30a19c14203e0b$var$styles.excerptMeta
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: authorAccountId,
            fullName: authorName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
            userId: authorAccountId,
            fullName: authorName,
            behavior: "link",
            isUnderlinedByDefault: false,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- style overrides to match legacy macro subtle link styling
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
            }
        })), Boolean(createdDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest",
            size: "small"
        }, intl.formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).excerptPostedOn, {
            date: (0, $gLc6G.formatBlogDate)(createdDate, intl)
        })))))), contentMode === 'entire' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3d6e5aceb5d616$export$af9dc05418a334e), {
            atlasDocFormat: content.body?.atlas_doc_format?.value,
            mediaToken: content.body?.atlas_doc_format?.mediaToken?.token,
            contentId: content.id ?? '',
            spaceKey: content.space?.key ?? '',
            spaceId: content.space?.id ?? undefined,
            RendererWrapper: RendererWrapper
        }), contentMode === 'excerpts' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea3d6e5aceb5d616$export$af9dc05418a334e), {
            atlasDocFormat: content.macroExcerpt?.atlasDocFormat,
            mediaToken: content.body?.atlas_doc_format?.mediaToken?.token,
            contentId: content.id ?? '',
            spaceKey: content.space?.key ?? '',
            spaceId: content.space?.id ?? undefined,
            RendererWrapper: RendererWrapper,
            fallback: content.excerpt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, content.excerpt) : null
        }), labels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc0342895ad69cf4$export$2d4801a6a75948a8), {
            labels: labels,
            spaceKey: spaceKey
        })));
    }));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eKMV3 = parcelRequire("eKMV3");














var $1NBp8 = parcelRequire("1NBp8");


const $590573fe5e39b249$var$blogPostsEmptyBg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAADwCAMAAACAE47JAAAACVBMVEX///9wcHBwcHDMVYRVAAAAA3RSTlMAESJ8z6YqAAADxklEQVR42u3d0W4bMQxE0bn8/4/uQwMs2gXiLCVqyHbn3drjAQMlsKzod4i/AgBqH+LbAIyUXwGayge+gcgE2pQ+0h9rAS99KD/2BCz0qfrYGgz0ifooCAb6LH2UBQN9Cj5qg4E+AB8HgoHeGx8xFh/nMpgegYHeEh+ng5/ux0eMxYcng+mBke7HR4zFhzWD6YGD7seHP4PpgYHuxcdce8RYfMy1R4zFx1x79EoHejYk6POKp5+dcrrfHh0z2c6/b2ewXXylFV7JdHgnaDGA1z7zDaBtgab2lhuwdofBdgkM9mnlo5qAwT5Ij+rCYLvEYLtgnv0Kg+1isF1isF0MtovBdjHYLgbbRbzHnS12DPa+eDQXr5OZbGewXbz2yz4Vr7l2aSxec+1yZDBdWOl+u1wZTBdz6WIuXeyiOy7J2EHHdE/GMh3fNROs0eNjoKH95y+GZvZn8waN7M9fCU3sV+lOfZ7u1yfp2WC2S7EQ6u2f6X58nu7H5+l+fZ7ux6fpfjxpuh9Pmu7H46JHnLS3u8aJNN2Pz9P9U5On+4tP0/148nS/PU3340nT/XYzPaLW3vXKMgrpfrvU9ex5nu4vPkE32v8Iebrfnqb7Bz5N99upofvtUnS2t6AHSoQKut8u0due/izJb+c7OkPvr9Fcu6TuM8O3dInG9p/vFACt9iaeLgR0safWgb52fQ7Y7SysgvlHda0AnHaW6BJGe4Jepd9Qu/Ec9GrtkgnP8lOVCQ57gl6GX32ksjlv30YXp0eGG92IZ6l27/n5paq0Foy1a5KdG905NAvPch/+x0C32NlNl46NzH66HLVrUzhfu/x2DHSHnRvda8/VLrc9X7vc9nztamEnT6+376udIro4V7ua2DvQVV47ZXSdql1d7LSgU1w7dXRxpPZG3zvuQdeJiWn0tWN60HVgYtTIThM6lbVTSlf5xKiTnS50iifm87EAMNSepLPrQDGlE3OnY/1nbwt0Eo0Yar/TKTgLUjfsN/mOhRfsOXpiZR9dEU+fUj3tJOiJWswTcz2ixk45PR6ktnYe0in8mLZs2G/V2Gt/Ro8otFNJJzGP/onhKr2s9kI6Ea1q9//tfsVAbz4xElFdOy/9lkjFOuzz6Ryg04pOYe289P+dTjzKS99C10vfsyVV0ulE56VvGHbm0vU0NcUY6MZfwHDT87XLTM/Xjpuer73+Mtiq2nHT87XLTM/bZabnV6YZXWTlfrrIyv10kZX76aJQLpl3ay3EunGgleC7VQ4tJlf6Oh6tx3E7MdoTEvJM+Ip2hp3wX1/Ls3M7es6xAAAAAElFTkSuQmCC';
const $590573fe5e39b249$var$styles = {
    container: "_19itia51 _2rko12b0 _1tke176v _12vemgnk _ouxl1osq"
};
const $590573fe5e39b249$export$fddf379e22a74b00 = ({ spaceKey: spaceKey })=>{
    const createBlogPostHref = spaceKey ? (0, $1NBp8.CREATE_CONTENT).toUrl({
        spaceKey: spaceKey,
        contentType: 'blog'
    }, {
        query: {
            spaceKey: spaceKey,
            withFallback: true,
            source: 'blog-posts-macro'
        }
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        padding: "space.300",
        testId: "blog-posts-empty-state",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $590573fe5e39b249$var$styles.container,
        style: {
            backgroundImage: `url(${$590573fe5e39b249$var$blogPostsEmptyBg})`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).emptyHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).emptyContent)), createBlogPostHref && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "default",
        href: createBlogPostHref,
        testId: "create-blog-post-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).createPost)))));
};


const $944ec36b0e65d112$var$BlogPostsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, RendererWrapper: RendererWrapper })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentMode: contentMode, error: error, hasNextPage: hasNextPage, isLoadingMore: isLoadingMore, loadMore: loadMore, loadMoreError: loadMoreError, loading: loading, nodes: nodes, serializedMacroParameters: serializedMacroParameters, spaceKey: spaceKey } = (0, $5c663987d2c4a146$export$bcd1293b3c1159b6)(macroParams, macroDefaultProps);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        padding: "space.300",
        testId: "blog-posts-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $24902acfefadcb18$export$a7357cdd1f0b0168).loading)
    })));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        padding: "space.300",
        testId: "blog-posts-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: error
    }));
    let content;
    if (nodes.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $590573fe5e39b249$export$fddf379e22a74b00), {
        spaceKey: spaceKey
    });
    else if (contentMode === 'titles') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dc99b02bed969e7$export$9c7aae348aeccd51), {
        nodes: nodes
    });
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe30a19c14203e0b$export$d55fd724d7ffd08), {
        nodes: nodes,
        contentMode: contentMode,
        RendererWrapper: RendererWrapper
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-fabric-macro": attributes?.macroId,
        "data-macro-body": "",
        "data-macro-parameters": serializedMacroParameters,
        "data-testid": "blog-posts-macro"
    }, content, contentMode === 'entire' && hasNextPage && loadMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: loadMore,
        isLoading: isLoadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).loadMore))), loadMoreError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $944ec36b0e65d112$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24902acfefadcb18$export$a7357cdd1f0b0168).error);
const $944ec36b0e65d112$export$5725dc22f3c5370a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $944ec36b0e65d112$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($944ec36b0e65d112$var$BlogPostsMacroRendererComponent, props));
module.exports["BlogPostsMacroRenderer"] = $944ec36b0e65d112$export$5725dc22f3c5370a;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $22Zs7 = parcelRequire("22Zs7");


var $9zU5G = parcelRequire("9zU5G");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");


var $5XsiK = parcelRequire("5XsiK");


var $6OL2O = parcelRequire("6OL2O");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $6OL2O.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $5XsiK.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>(0, $5XsiK.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $5XsiK.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22Zs7.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $eW61a.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $4N3op.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("3DjKS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ad9913fe9e202296$var$baseStyles = null;
const $ad9913fe9e202296$var$justifyStartStyles = null;
const $ad9913fe9e202296$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $ad9913fe9e202296$var$TagGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { alignment: t1, titleId: titleId, label: label, children: children } = t0;
    const alignment = t1 === undefined ? "start" : t1;
    const t2 = alignment === "start" && "_1bah1y6m";
    const t3 = alignment === "end" && "_1bahesu3";
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            t2,
            t3
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== label || $[5] !== ref || $[6] !== t4 || $[7] !== titleId) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "group",
            ref: ref,
            "aria-label": label,
            "aria-labelledby": titleId,
            className: t4
        }, children);
        $[3] = children;
        $[4] = label;
        $[5] = ref;
        $[6] = t4;
        $[7] = titleId;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ])
    }, children);
});
var $ad9913fe9e202296$export$2e2bcd8739ae039 = $ad9913fe9e202296$var$TagGroup;
module.exports["default"] = $ad9913fe9e202296$export$2e2bcd8739ae039;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});


//# sourceMappingURL=BlogPostsMacroRenderer.dccee9ba.js.map
